import React from "react";
import PropTypes from "prop-types";
import { Route } from "react-router";
import PageNotFound from "../pages/PageNotFound";
import AuthorizeRoute from "../auth/AuthorizeRoute";
import useFeatureFlag from "../hooks/useFeatureFlag";
import { CircularLoader } from "../atoms/Loaders";
import { featureService } from "../services";

/**
 * A custom react-router route used for handling routes that need to be behind a feature flag.
 * @returns {Route} - React router route.
 */
function FeatureFlagRoute({ path, component, featureKey, requireAuth, ...props }) {
  const [featureEnabled, ready] = useFeatureFlag(
    featureKey,
    featureService.isFeatureEnabled,
    requireAuth
  );
  if (!ready) return <CircularLoader />;
  if (featureEnabled) {
    if (requireAuth) return <AuthorizeRoute exact path={path} component={component} {...props} />;
    return <Route exact path={path} component={component} {...props} />;
  }
  return (
    <Route path="*">
      <PageNotFound />
    </Route>
  );
}

FeatureFlagRoute.propTypes = {
  path: PropTypes.string.isRequired,
  component: PropTypes.func.isRequired,
  featureKey: PropTypes.string.isRequired,
  requireAuth: PropTypes.bool.isRequired,
};

export default FeatureFlagRoute;
